import Vue from 'vue'
import app from './App.vue'
import VueRouter from 'vue-router';

import store from './store'
import router from './router'
import './assets/styles.scss'

//import { settings } from './settings'
import { i18n } from './setup/i18n-setup'



Vue.config.productionTip = false
Vue.use(VueRouter)




const globalMethods = {
    //async authenticate(returnPath) {
    //    const user = await this.$root.getUser(); //see if the user details are in local storage
    //    //if (!!user) {
    //    if (user) {
    //        this.isAuthenticated = true;
    //        this.user = user;
    //    } else {
    //        await this.$root.signIn(returnPath);
    //    }
    //},
    //async getUser() {
    //    try {
    //        let user = await this.mgr.getUser();
    //        return user;
    //    } catch (err) {
    //        console.log(err);
    //    }
    //},
    //signIn(returnPath) {
    //    returnPath ? this.mgr.signinRedirect({ state: returnPath })
    //        : this.mgr.signinRedirect();
    //}
}
const globalData = {
    //isAuthenticated: false,
    //user: '',
    //mgr: mgr
}


//Vue.mixin({
//    data: function () {
//        return {
//            locale: settings.default_locale
//        }
//    }
//})
//Vue.prototype.$locale = settings.default_locale;

new Vue({
    router,
    store,
    i18n,
    data: globalData,
    methods: globalMethods,
    render: h => h(app),
}).$mount('#app')
